export const SAVE_CONTACT = 'SAVE_CONTACT';
export const SAVE_CONTACT_SUCCESS = 'SAVE_CONTACT_SUCCESS';
export const SAVE_CONTACT_FAILURE = 'SAVE_CONTACT_FAILURE';
export const ADD_CONTACT_TO_THE_LIST = 'ADD_CONTACT_TO_THE_LIST';
export const UPDATE_CONTACT_IN_THE_LIST = 'UPDATE_CONTACT_IN_THE_LIST';



// WEBPACK FOOTER //
// ./src/modules/ContactForm/actionTypes.js